<script>

import CarouselComponent from "@/views/components/CarouselComponent.vue";
import {mapState} from "vuex";

export default {
  components: {
    CarouselComponent
  },
  computed: {
    ...mapState(['isFreeUser','currentSeason'])
  },
  methods:{
    home(){
      this.$router.push('/profile');
    },
    packages(){
      this.$router.push('/upgrade-package');
    }
  }
}

</script>

<template>
<div class = "container">
  <div class = "row">

    <div class = "col-12 px-3 mt-2">
      <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="logo col-5" alt="logo" />
    </div>
    <div class = "d-flex flex-column justify-content-center align-items-center col-12 mb-4 mt-4" >
      <CarouselComponent :season="currentSeason" />

    </div>

    <div class = "bold text-center col-12 mt-5">Manage your Mzansi</div>
    <div class = "bold text-center">Rhythm Subscription</div>

    <div class = "normalText text-center mt-2">You are currently on the <span class = "boldText"> free version</span> of</div>
    <div class="normalText text-center">Mzansi Rhythm. Join VIP for extra </div>
    <div class="normalText text-center">questions and more prizes.</div>

    <div class='row justify-content-center'>
      <div class=" vip mx-auto text-center mt-4 border p-3 col-11" @click = "packages">Upgrade to VIP</div>
    </div>

    <div class = "returnHome text-center mt-4" @click = "home">Return Home</div>



  </div>

</div>
</template>

<style scoped>

.vip{
  background-color:#FFCB05;
  border-radius: 30px;
  font-family: "Clash Display", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 19px;
  color: #000000;
}

.returnHome{
  font-family: "Clash Display", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: black;
}

.bold{
  font-family: "Clash Display", sans-serif;
  font-size: 19px;
  font-style: normal;
  font-weight: 600;
  color: #000F56;
}

.normalText{
  font-family: "Clash Display", sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #000F56;
}

.boldText{
  font-family: "Clash Display", sans-serif;
  font-weight: 600;
}

</style>